import { z } from 'zod';
import { CulinaryStudioArticleModelSchema } from 'entities/culinary-studio-article';
import { GetCulinaryStudioArticleByUidApiResponseSchema } from '../store';

// eslint-disable-next-line max-len
export const createCulinaryStudioArticleFromGetCulinaryStudioArticleApiResponse = (
    (response: z.infer< typeof GetCulinaryStudioArticleByUidApiResponseSchema>) => (
        CulinaryStudioArticleModelSchema.parse({
            uid: response.data.slug,
            name: response.data.name,
            description: response.data.description,
            category: response.data.category && {
                uid: response.data.category.slug,
                name: response.data.category.name,
            },
            images: response.data.images?.map(({ url }) => ({
                url,
            })),
            portions: response.data.portions?.map(({
                value,
                meassure,
                description,
                weight,
                price,
                currency,
            }) => ({
                value,
                meassure,
                description,
                weight,
                price,
                currency: currency && {
                    uid: currency.slug,
                    name: currency.name,
                    abbreviation: currency.abbreviation,
                },
            })),
            sets: response.data.sets?.map(({
                name,
                elements,
            }) => ({
                name,
                elements: elements?.map(({
                    name: name2,
                    meassure,
                    value,
                }) => ({
                    name: name2,
                    meassure,
                    value,
                })),
            })),
            includedServices: response.data.includedServices?.map(({
                name,
                description,
            }) => ({
                name,
                description,
            })),
            nonIncludedServices: response.data.nonIncludedServices?.map(({
                name,
            }) => ({
                name,
            })),
            recommendations: response.data.recommendations?.map(({
                slug,
                name,
                weight,
                price,
                currency,
                images,
            }) => ({
                uid: slug,
                name,
                weight,
                price,
                currency: currency && {
                    uid: currency.slug,
                    name: currency.name,
                    abbreviation: currency.abbreviation,
                },
                image: images && {
                    url: images[0].url,
                },
            })),
        })
    )
);
